<template>
  <div id="app">
    <ajax-errors />
    <div v-if="this.$store.state.crisisManager.alert" class="crisis-notification">
      <CrisisManager v-on:crisisActivated="crisisActivated()" />
    </div>

    <div
      v-if="$store.state.auth.loggedIn && ($store.state.auth.user.role === 'partner' || $store.state.auth.user.role === 'dmo')"
      class="container-fluid">
      <div class="row bannerSection">
        <div class="col pt-2 pb-2 bannerCol" v-for="(alert, index) in alerts" :key="alert._id"
          :class="setBannerItemColor(index, alert.level)" :id="'alertBanner' + index">
          <div class="flexCenterColumnContent d-flex align-items-center">
            <a @click="showAlertModal(alert)">
              <span v-if="alert.level === 'State of Emergency'">
                <EmergencyIcon :width="30" :height="30" :fill="'black'" class="bannerIcon bannerIconEmergency" />
                <a href="#" class="bannerButtonBlack" @keydown.enter="showAlertModal(alert)"> {{ alert.title }}</a>
              </span>
              <span v-else>
                <NotificationBellIcon :width="30" :height="30" :fill="'white'" class="bannerIcon" />
                <a href="#" class="bannerButton" @keydown.enter="showAlertModal(alert)"> {{ alert.title }}</a>
              </span>
            </a>
            <div class="nextBanner justify-content-end">
              <a class="nextBanner" @click="nextBanner(index)"> Next > </a>
            </div>
          </div>
          <div class="alertCount">Alert {{ index + 1 }} of {{ alerts.length }}</div>
        </div>
      </div>
    </div>

    <div>
      <div class="container-fluid">
        <div class="row no-gutters border-bottom p-2 shadow-bottom">
          <div class="col-lg-12">
            <div id="nav" class="nav-wrapper">
              <b-navbar toggleable="lg" type="light" variant="info">
                <b-navbar-brand to="/"><img src="/images/state.svg" class="logo img-fluid"
                    alt="Sweet Home Alabama, select to go to the home page" /></b-navbar-brand>
                <div class="nav-partners">
                  <h2 class="nav-partners-head">
                    Alabama Tourism Partners
                    <br />
                    <p class="nav-partners-body">The official site for location and event administration</p>
                  </h2>
                </div>

                <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

                <!--nav for admin only -->
                <b-collapse v-if="$store.state.auth.loggedIn && $store.state.auth.user.role === 'admin'" class="nav-left"
                  id="nav-collapse" is-nav>
                  <b-navbar-nav class="pl-3">
                    <img src="/images/dashboard-icon.svg" class="logo icon-nav img-fluid" alt="Icon Dashboard" />
                    <b-nav-item to="/admin" class="nav-heading"> Dashboard </b-nav-item>
                    <img src="/images/organizations-icon.svg" class="logo icon-nav img-fluid" alt="Icon Partners" />
                    <b-nav-dropdown text="Partners" ref="dropdownPartners" toggle-class="nav-heading"
                      class="main-dropdown main-nav-margin">
                      <b-nav-item to="/events" v-if="$store.state.auth.loggedIn">Events</b-nav-item>
                      <b-nav-item to="/locations" v-if="$store.state.auth.loggedIn">Locations</b-nav-item>
                      <b-nav-item to="/partners" v-if="$store.state.auth.loggedIn">Organizations</b-nav-item>
                      <b-nav-item to="/users" v-if="$store.state.auth.loggedIn">Users</b-nav-item>
                    </b-nav-dropdown>
                    <img src="/images/content-icon.svg" class="logo icon-nav img-fluid" alt="Icon Content" />
                    <b-nav-dropdown text="Content" ref="dropdownContent" toggle-class="nav-heading"
                      class="main-dropdown main-nav-margin">
                      <b-nav-item :to="{ name: 'areas list' }" v-if="$store.state.auth.loggedIn">Areas</b-nav-item>
                      <b-nav-item :to="{ name: 'city list' }" v-if="$store.state.auth.loggedIn">Cities</b-nav-item>
                      <b-nav-item :to="{ name: 'profiles list' }" v-if="$store.state.auth.loggedIn">Profiles</b-nav-item>
                      <b-nav-item :to="{ name: 'dishes list' }" v-if="$store.state.auth.loggedIn">Dishes</b-nav-item>
                      <b-nav-item :to="{ name: 'roadtrips list' }" v-if="$store.state.auth.loggedIn">Road
                        Trips</b-nav-item>
                    </b-nav-dropdown>
                    <img src="/images/setting-icon.svg" class="logo icon-nav img-fluid" alt="Icon Setting" />
                    <b-nav-dropdown text="Settings" ref="dropdownSettings" toggle-class="nav-heading"
                      class="main-dropdown main-nav-margin">
                      <b-nav-item :to="{ name: 'alerts list' }" v-if="$store.state.auth.loggedIn">Alerts</b-nav-item>
                      <b-nav-item :to="{ name: 'badges list' }" v-if="$store.state.auth.loggedIn">Badges</b-nav-item>
                      <b-nav-item :to="{ name: 'social networks list' }" v-if="$store.state.auth.loggedIn">Social
                        Networks</b-nav-item>
                    </b-nav-dropdown>
                  </b-navbar-nav>

                  <b-navbar-nav class="ml-auto">
                    <b-nav-item-dropdown text="My Organizations" toggle-class="nav-heading">
                      <b-dropdown-item v-for="org in $store.state.auth.mUser.organizations" :key="org._id"
                        :to="{ name: 'org detail', params: { orgId: org._id } }">
                        {{ org.name }}
                      </b-dropdown-item>
                    </b-nav-item-dropdown>
                    <b-nav-item-dropdown :text="fullName">
                      <b-dropdown-item
                        :to="{ name: 'users detail', params: { userId: $store.state.auth.mUser._id } }">Profile</b-dropdown-item>
                      <b-dropdown-item @click="signOut()">Sign Out</b-dropdown-item>
                    </b-nav-item-dropdown>
                  </b-navbar-nav>
                </b-collapse>

                <!--nav for editors -->
                <b-collapse v-else-if="$store.state.auth.loggedIn && $store.state.auth.user.role === 'editor'"
                  class="nav-left" id="nav-collapse" is-nav>
                  <b-navbar-nav class="pl-3">
                    <img src="/images/dashboard-icon.svg" class="logo icon-nav img-fluid" alt="Icon Dashboard" />
                    <b-nav-item to="/admin" class="nav-heading"> Dashboard </b-nav-item>
                    <img src="/images/organizations-icon.svg" class="logo icon-nav img-fluid" alt="Icon Partners" />
                    <b-nav-dropdown text="Partners" ref="dropdownPartners" toggle-class="nav-heading"
                      class="main-dropdown main-nav-margin">
                      <b-nav-item to="/events" v-if="$store.state.auth.loggedIn">Events</b-nav-item>
                      <b-nav-item to="/locations" v-if="$store.state.auth.loggedIn">Locations</b-nav-item>
                      <b-nav-item to="/partners" v-if="$store.state.auth.loggedIn">Organizations</b-nav-item>
                      <b-nav-item to="/users" v-if="$store.state.auth.loggedIn">Users</b-nav-item>
                    </b-nav-dropdown>
                    <img src="/images/cities-icon.svg" class="logo icon-nav img-fluid" alt="Icon Partners" />
                    <b-nav-item to="/cities" v-if="$store.state.auth.loggedIn" class="nav-heading">Cities</b-nav-item>
                  </b-navbar-nav>
                  <b-navbar-nav class="ml-auto">
                    <b-nav-item-dropdown text="My Organizations" toggle-class="nav-heading">
                      <b-dropdown-item v-for="org in $store.state.auth.mUser.organizations" :key="org._id"
                        :to="{ name: 'org detail', params: { orgId: org._id } }">
                        {{ org.name }}
                      </b-dropdown-item>
                    </b-nav-item-dropdown>
                    <b-nav-item-dropdown :text="fullName">
                      <b-dropdown-item
                        :to="{ name: 'users detail', params: { userId: $store.state.auth.mUser._id } }">Profile</b-dropdown-item>
                      <b-dropdown-item @click="signOut()">Sign Out</b-dropdown-item>
                    </b-nav-item-dropdown>
                  </b-navbar-nav>
                </b-collapse>

                <!--nav for limited editors -->
                <b-collapse v-else-if="$store.state.auth.loggedIn && $store.state.auth.user.role === 'limited_editor'"
                  class="nav-left" id="nav-collapse" is-nav>
                  <b-navbar-nav class="pl-3">
                    <img src="/images/calendar-icon.svg" class="logo icon-nav img-fluid" alt="Icon Events" />
                    <b-nav-item to="/events" v-if="$store.state.auth.loggedIn" class="nav-heading">Events</b-nav-item>
                    <img src="/images/map-location-icon.svg" class="logo icon-nav img-fluid" alt="Icon Locations" />
                    <b-nav-item to="/locations" v-if="$store.state.auth.loggedIn" class="nav-heading">Locations</b-nav-item>
                    <img src="/images/organization-icon.svg" class="logo icon-nav img-fluid" alt="Icon Organizations" />
                    <b-nav-item to="/partners" v-if="$store.state.auth.loggedIn" class="nav-heading">Organizations</b-nav-item>
                  </b-navbar-nav>
                  <b-navbar-nav class="ml-auto">
                    <b-nav-item-dropdown text="My Organizations" toggle-class="nav-heading">
                      <b-dropdown-item v-for="org in $store.state.auth.mUser.organizations" :key="org._id"
                        :to="{ name: 'org detail', params: { orgId: org._id } }">
                        {{ org.name }}
                      </b-dropdown-item>
                    </b-nav-item-dropdown>
                    <b-nav-item-dropdown :text="fullName" class="main-dropdown">
                      <b-dropdown-item
                        :to="{ name: 'users detail', params: { userId: $store.state.auth.mUser._id } }">Profile</b-dropdown-item>
                      <b-dropdown-item @click="signOut()">Sign Out</b-dropdown-item>
                    </b-nav-item-dropdown>
                  </b-navbar-nav>
                </b-collapse>

                <!--nav for partners -->
                <b-collapse v-else-if="$store.state.auth.loggedIn" class="nav-left" id="nav-collapse" is-nav>
                  <b-navbar-nav class="pl-3">
                    <img src="/images/organization-icon.svg" class="logo icon-nav img-fluid" alt="Icon Partners" />
                    <b-nav-item to="/partners" v-if="$store.state.auth.loggedIn"
                      class="nav-heading">Organizations</b-nav-item>
                    <img src="/images/calendar-icon.svg" class="logo icon-nav img-fluid" alt="Icon Partners" />
                    <b-nav-item to="/events" v-if="$store.state.auth.loggedIn" class="nav-heading">Events</b-nav-item>
                    <img src="/images/map-location-icon.svg" class="logo icon-nav img-fluid" alt="Icon Partners" />
                    <b-nav-item to="/locations" v-if="$store.state.auth.loggedIn"
                      class="nav-heading">Locations</b-nav-item>
                    <template v-if="$store.state.auth.user.role === 'dmo'">
                      <img src="/images/cities-icon.svg" class="logo icon-nav img-fluid" alt="Icon Partners" />
                      <b-nav-item to="/cities" v-if="$store.state.auth.loggedIn" class="nav-heading">Cities</b-nav-item>
                    </template>
                  </b-navbar-nav>
                  <b-navbar-nav class="ml-auto">
                    <b-nav-item-dropdown text="My Organizations" toggle-class="nav-heading">
                      <b-dropdown-item v-for="org in $store.state.auth.mUser.organizations" :key="org._id"
                        :to="{ name: 'org detail', params: { orgId: org._id } }">
                        {{ org.name }}
                      </b-dropdown-item>
                    </b-nav-item-dropdown>
                    <b-nav-item-dropdown :text="fullName" class="main-dropdown">
                      <b-dropdown-item
                        :to="{ name: 'users detail', params: { userId: $store.state.auth.mUser._id } }">Profile</b-dropdown-item>
                      <b-dropdown-item @click="signOut()">Sign Out</b-dropdown-item>
                    </b-nav-item-dropdown>
                  </b-navbar-nav>
                </b-collapse>
              </b-navbar>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End nav-wrapper  -->
    <router-view :key="$route.path" />
    <b-modal id="alert-modal" :title="alert.title" hide-footer size="lg" header-close-content="Close">
      <template #modal-title>
        <span v-if="alert.level === 'State of Emergency'">
          <EmergencyIcon :width="30" :height="30" :fill="'#104B66'" class="mr-4" /><span class="soeTitle">{{ alert.level
          }} Alert</span>
        </span>
        <span v-else>
          <NotificationBellIcon :width="30" :height="30" :fill="'#104B66'" class="mr-4" />{{ alert.level }} Alert
        </span>
      </template>
      <h5 class="modal-title">{{ alert.title }}</h5>
      <div class="mb-4" id="alertMessage" v-html="alert.message"></div>
      <b-button class="modal-button mb-5 shadow-none" size="sm" :href="alert.url" target="_blank" rel="noopener noreferrer"> Additional Information
      </b-button>
      <!-- Accommodation Resources and Additional Resources only relevent to .travel alerts -->
      <!-- <div v-if='showAdditionalResources' class="additional-resources-section">
          <h6 class="modal-heading">Additional Resources</h6>
          <div class="row pl-1">
            <div v-for="(button, index) in alert.resources" :key="index">
              <b-button class="ml-2 pl-5 pr-5 additional-resource-button shadow-none" size="sm" variant="outline-info" :href=button.url target="_blank">
                {{button.buttonText}}
              </b-button>
            </div>
          </div>
        </div>
        <div v-if="alert.showAccommodation === true" id="accommodations">
          <h1 class="modal-title">Accommodations</h1>
          <hr />
          <a class="cm-logo-link" href="https://www.booking.com/region/us/alabama.html" rel='noopener' target="_blank">
            <img src="/images/Booking.png" alt="Booking.com logo" class="cm-logo">
          </a>
          <a class="cm-logo-link" href="https://www.expedia.com/Destinations-In-Alabama.d202.Hotel-Destinations" rel='noopener' target="_blank">
            <img src="/images/Expedia.png" alt="Expedia logo" class="cm-logo ml-3">
          </a>
          <a class="cm-logo-link" href="https://www.orbitz.com/Destinations-In-Alabama.d202.Hotel-Destinations" rel='noopener' target="_blank">
            <img src="/images/Orbitz.png" alt="Orbitz logo" class="cm-logo  ml-3">
          </a>
        </div> -->
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios';
import CrisisManager from '@/components/Notifications/CrisisManager.vue';
import EmergencyIcon from '@/components/Notifications/EmergencyIcon.vue';
import NotificationBellIcon from '@/components/Notifications/NotificationBellIcon.vue';
import AjaxErrors from './AjaxErrors.vue';

export default {
  data() {
    return {
      crisisActive: false,
      alerts: [],
      alert: [],
      showAccommodation: false,
      showAdditionalResources: false,
      checkActivity: null,
    };
  },
  computed: {
    fullName() {
      return `${this.$store.state.auth.mUser.first_name} ${this.$store.state.auth.mUser.last_name}`;
    },
  },
  components: {
    AjaxErrors,
    CrisisManager,
    NotificationBellIcon,
    EmergencyIcon,
  },
  created() {
    this.checkActivity = setInterval(() => this.updateToken(), 60000);
  },
  async mounted() {
    if (this.$store.state.auth.user && this.$store.state.auth.user.tokens && this.$store.state.auth.user.tokens.IdToken) {
      axios.defaults.headers.common.Authorization = this.$store.state.auth.user.tokens.IdToken;
    }
    axios.interceptors.request.use(
      async (config) => {
        if (config.url.includes('s3.amazonaws.com')) {
          return config;
        }
        if (config.url.includes('/auth/signin') || config.url.includes('/auth/refresh') || config.url.includes('/getCrisis')) {
          return config;
        }
        const currentEpoch = Math.round(new Date().getTime() / 1000);
        if (currentEpoch > this.$store.state.auth.maxSessionExpires) {
          // max 7 day session from initial signin data passed, signout().
          this.signOut();
        }
        if (((Number(this.$store.state.auth.tokenExpires) - 2700) - Number(currentEpoch)) < 0) {
          // THIS CONSOLE LOG IS FOR MONITORING FUNCTIONALITY ON REFRESH
          console.log(`currentEpoch: ${currentEpoch} difference: ${Number(this.$store.state.auth.tokenExpires) - Number(currentEpoch)}`);
          const currentUser = this.$store.state.auth.user;
          if (!currentUser) {
            Promise.reject(new Error('user undefined'));
          }
          await axios
            .post(`${process.env.VUE_APP_API_ROOT}/auth/refresh`, {
              user: currentUser,
            })
            .then(({ data }) => {
              if (data && data.idToken) {
                // setting new token
                config.headers.Authorization = data.idToken;
                axios.defaults.headers.common.Authorization = data.idToken;
              } else {
                this.signOut();
              }
              // Update the token expire time
              this.$store.dispatch('auth/updateTokenExpire');
              this.$store.dispatch('auth/updateUserRole', data.role);

              return config;
            })
            .catch((error) => {
              console.log(JSON.stringify(error));
            });
        } else {
          // THIS CONSOLE LOG IS FOR MONITORING FUNCTIONALITY ON REFRESH
          console.log(`currentEpoch: ${currentEpoch} TOKEN expires in: ${Number(this.$store.state.auth.tokenExpires) - Number(currentEpoch)} seconds`);
        }
        return config;
      },
      (error) => Promise.reject(error)
    );
    // alerts banner
    await this.getAlerts();
  },
  watch: {
    $route() {
      if (this.$store.state.auth.loggedIn && this.$store.state.auth.user.role === 'admin') {
        this.$refs.dropdownPartners.hide(true);
        this.$refs.dropdownContent.hide(true);
        this.$refs.dropdownSettings.hide(true);
      } else if (this.$store.state.auth.loggedIn && this.$store.state.auth.user.role === 'editor') {
        this.$refs.dropdownPartners.hide(true);
      }
      this.$nextTick(() => {
        this.scrollToTop();
      });
    },
  },
  methods: {
    async updateToken() {
      try {
        if (this.$store.state.auth.loggedIn && this.$store.state.auth.user && this.$store.state.auth.user.tokens && this.$store.state.auth.user.tokens.IdToken) {
          // Create new refresh token
          await axios
            .post(`${process.env.VUE_APP_API_ROOT}/auth/refresh`, {
              user: this.$store.state.auth.user,
              browser: navigator.userAgent,
            })
            .then(({ data }) => {
              if (data && data.idToken) {
                // setting new token
                axios.defaults.headers.common.Authorization = data.idToken;
              } else {
                this.signOut();
              }
              // Update the token expire time
              this.$store.dispatch('auth/updateTokenExpire');
              this.$store.dispatch('auth/updateUserRole', data.role);
            })
            .catch((error) => {
              console.log(JSON.stringify(error));
            });
        } else {
          return;
        }
      } catch (err) {
        console.log('Error', err);
        this.signOut();
      }
    },
    async getAlerts() {
      await this.$store.dispatch('alerts/getAlerts');
      const reducedAlertsSet = this.$store.getters['alerts/getReducedAlertsSet'];
      this.alerts = reducedAlertsSet;
    },
    setBannerItemColor(index, level) {
      const backgroundColors = {
        0: 'darkBlue',
        1: 'oceanBlue',
        2: 'blueGreen',
        3: 'seaFoam',
        default: 'grey',
      };
      if (level === 'State of Emergency') {
        backgroundColors[index] = 'emergency';
      }
      return backgroundColors[index];
    },
    showAlertModal(alert) {
      this.alert = alert;
      /* eslint no-unused-expressions: ["error", { "allowTernary": true }] */
      this.alert.resources.length > 0 ? (this.showAdditionalResources = true) : (this.showAdditionalResources = false);
      this.showAccommodation = alert.showAccommodation;
      this.$bvModal.show('alert-modal');
    },
    nextBanner(index) {
      const nextIndex = index + 1;
      const alertsCount = this.alerts.length;
      if (alertsCount !== nextIndex) {
        const currentBanner = document.getElementById(`alertBanner${index}`);
        currentBanner.style.display = 'none';
        const nextBanner = document.getElementById(`alertBanner${index + 1}`);
        nextBanner.style.display = 'initial';
      } else {
        const currentBanner = document.getElementById(`alertBanner${index}`);
        currentBanner.style.display = 'none';

        const nextBanner = document.getElementById('alertBanner0');
        nextBanner.style.display = 'initial';
      }
    },
    crisisActivated() {
      this.crisisActive = false;
    },
    forceUpdate() {
      this.$forceUpdate();
    },
    signOut() {
      this.$store
        .dispatch('auth/signOut')
        .then(() => {
          this.$store.dispatch('auth/setRedirectUrl', null);
          this.loggedIn = false;
          this.$router.push('/');
        })
        .catch((err) => {
          this.errorMsg = err.message;
        });
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style scoped>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.crisis-notification {
  padding-bottom: 61px;
}

div>>>.bg-info {
  background-color: white !important;
}

.nav-partners {
  margin-left: 0px;
  margin-right: 20px;
}

.nav-partners-head {
  font-family: 'klinicslabbold';
  color: #1a3138;
  font-weight: 300;
  font-size: 30px;
  font-size: 1.5rem;
}

.nav-partners-body {
  font-family: 'klinicslabbold';
  font-size: 12px;
  line-height: 1em;
  margin: 0px;
}

@media only screen and (max-width: 1024px) {
  .nav-partners {
    margin-left: 0px;
  }
}
</style>

<style>
body {
  background-color: #f8f8f8 !important;
}

.container-fluid {
  padding-left: 0 !important;
  padding-right: 0 !important;
  background-color: white;
}

.nav-wrapper {
  padding-left: 15px;
  padding-right: 15px;
}

.shadow-bottom {
  -webkit-box-shadow: 0px 0px 5px 0px black;
  box-shadow: 0px 0px 5px 0px black;
}

.nav-heading:focus,
.nav-link:focus {
  outline: none;
}

.nav-heading a:hover {
  text-decoration: none;
}

.nav-heading:focus-visible,
.nav-link:focus-visible {
  outline-style: dashed;
  outline-color: #4e97b2;
  outline-offset: 0px;
  outline-width: 1px;
  color: #32557f;
  text-decoration: none;
}

.nav-heading {
  margin-right: 1rem;
}

.nav-heading a {
  color: #2c3e50;
  padding-left: 0rem !important;
  padding-right: 0rem !important;
  margin-left: 0.7rem;
  margin-right: 0.7rem;
  text-decoration: none;
}

.nav-heading {
  flex-direction: row-reverse;
}

.navbar-nav .dropdown-menu {
  padding-left: 10px;
}

.nav-heading,
.main-dropdown .dropdown-menu {
  border-bottom: 3px solid transparent;
}

.navbar-expand-lg .navbar-nav .nav-link {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.nav-link.dropdown-toggle:hover,
.nav-link.dropdown-toggle:focus-visible,
.main-dropdown .dropdown-menu {
  border-bottom: 3px solid #4e97b2;
}

.main-nav-margin {
  margin: 0px 10px 0px 10px;
}

.icon-nav {
  display: inline-block;
}

.nav-link {
  padding: 0.5rem 1rem !important;
}

.nav-heading .nav-link:hover {
  border-bottom: 3px solid #4e97b2;
}

.nav-heading a.router-link-exact-active {
  color: #4e97b2;
  border-bottom: 3px solid #4e97b2;
}

.nav-heading a.router-link-exact-active:focus,
.nav-heading a.router-link-exact-active:hover {
  color: #4e97b2;
  text-decoration: none;
}

.flexCenterColumnContent {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
}

.bannerIcon {
  cursor: pointer;
  margin: 0 0 5px 0;
}

#alertBanner0 a.bannerButton:hover,
#alertBanner0 a.bannerButton:active,
#alertBanner0 a.bannerButton:focus {
  cursor: pointer;
  text-decoration: none !important;
  color: lightgrey;
  border-bottom: 1px solid lightgrey;
}

.bannerButton {
  color: white;
  font-size: 1.3rem;
}

.bannerButton:focus,
.bannerButton:focus-visible,
.bannerButton:active {
  outline-style: dashed !important;
  outline-color: #4e97b2 !important;
  outline-offset: 5px !important;
  outline-width: 1px !important;
  text-decoration: none !important;
  color: #2c3e50;
  border-bottom: 1px solid currentColor;
}

.bannerButton:hover {
  cursor: pointer;
  text-decoration: none;
  color: #2c3e50;
  border-bottom: 1px solid currentColor;
}

.bannerButtonBlack {
  color: black;
  font-size: 1.3rem;
}

.bannerButtonBlack:focus,
.bannerButtonBlack:focus-visible,
.bannerButtonBlack:active {
  outline-style: dashed !important;
  outline-color: black !important;
  outline-offset: 5px !important;
  outline-width: 1px !important;
  text-decoration: none !important;
  color: black;
  border-bottom: 1px solid currentColor;
}

.bannerSection {
  display: flex;
  flex-direction: row;
}

.nextBanner {
  display: none;
  float: right;
  margin-right: 10px;
  margin-top: 5px;
  font-size: 1rem;
}

.alertCount {
  display: none;
}

.bannerIconEmergency {
  margin: 0 0 5px 0;
}

@media only screen and (max-width: 1890px) {
  .bannerIconEmergency {
    margin: 0 auto;
    display: inline-block;
  }

  .bannerIcon {
    margin: 0 auto;
    display: inline-block;
  }

  .bannerButtonBlack {
    line-height: 1rem;
  }
}

@media only screen and (max-width: 600px) {
  .bannerSection {
    flex-direction: column;
    height: 75px;
  }

  #alertBanner1,
  #alertBanner2,
  #alertBanner3 {
    display: none;
  }

  .emergency .alertCount {
    color: black !important;
  }

  a.bannerButtonBlack {
    display: inline-block;
    max-width: 200px;
    line-height: 1em;
    text-decoration: underline;
    margin: auto;
    position: absolute;
    top: 10px;
    left: 0;
    bottom: 0;
    right: 0;
    text-align: center;
    font-size: 1rem;
  }

  a.bannerButton {
    text-decoration: underline;
    text-underline-offset: 3px;
    display: inline-block;
    max-width: 200px;
    line-height: 1em;

    margin: auto;
    position: absolute;
    top: 20px;
    left: 0;
    bottom: 0;
    right: 0;
    text-align: center;
  }

  .nextBanner {
    display: initial;
    color: currentColor;
  }

  .alertCount {
    display: initial;
    color: white;
    font-size: 0.9rem;
    display: block;
    position: absolute;
    margin: auto;
    top: 51px;
    left: 0;
    bottom: 0;
    right: 0;
    margin-top: 0px;
    text-align: center;
  }

  .bannerButton {
    margin-left: 50px;
  }

  .bannerButtonBlack {
    margin-left: 50px;
  }

  .bannerIcon {
    display: none;
  }

  .flexCenterColumnContent {
    display: initial;
    flex-direction: initial;
    height: initial;
    justify-content: normal;
  }

  .soeTitle {
    font-size: 1.3rem;
  }
}

.bannerCol {
  color: white;
  flex: 1;
}

/* TO DO: replace with variables */
.darkBlue {
  background-color: #104b66;
}

.oceanBlue {
  background-color: #4e97b2;
  color: white;
}

.blueGreen {
  background-color: #6daab2;
  color: white;
}

.seaFoam {
  background-color: #a2c8ce;
  color: white;
}

.emergency {
  background-color: var(--orange-500);
  color: black;
}

.modal-title {
  color: var(--blue-700);
  font-family: klinicslabbold;
  font-weight: 500;
  font-size: 1.5rem;
  margin: 0;
}

.modal-heading {
  color: var(--blue-700);
  font-family: klinicslabbold;
}

.modal-button {
  background-color: var(--blue-700) !important;
}

.modal-button:hover {
  background-color: #6f98a7 !important;
}

.modal-body {
  color: #6f98a7;
}

.additional-resource-button {
  color: #4a7e91 !important;
}

.additional-resource-button:hover {
  background-color: var(--blue-700) !important;
  color: white !important;
}

button.close:focus-visible,
.modal-title:focus-visible,
.modal-heading:focus-visible,
.modal-button:focus-visible,
.additional-resource-button:focus-visible {
  outline-style: dashed !important;
  outline-color: #4e97b2 !important;
  outline-offset: 5px !important;
  outline-width: 1px !important;
  text-decoration: none !important;
}

button.close {
  color: #6f98a7;
  font-size: 0.8rem;
  position: relative;
  top: 15px;
  right: 6px;
}

button.close:hover {
  background-color: white;
  border: 1px dashed #6f98a7;
}

.cm-logo {
  width: 25%;
}

.cm-logo-link:focus-visible {
  outline-style: dashed !important;
  outline-color: #4e97b2 !important;
  outline-offset: 5px !important;
  outline-width: 1px !important;
  text-decoration: none !important;
}

.bannerIcons {
  width: 30px;
  height: 30px;
}
</style>
